<script setup lang="ts">
</script>
<template>
    <div class="circle" />
</template>
<style lang="scss" scoped>
.circle {
    height: 2.4rem;
    width: 2.4rem;
    border-radius: 50%;
    background-color: var(--gray);
}
</style>
